import type { AxiosInstance } from 'axios'
import { getApiLink } from '@/utils/api-urls'
import createApiClient, { AXIOS_DEFAULT_OPTIONS } from '@/utils/create-api-client'
import { useWorkflow } from '@/composables/workflow/useWorkflow'

let executorApiClient: AxiosInstance | undefined

const createExecutorApi = () => {
    const client = createApiClient(AXIOS_DEFAULT_OPTIONS)

    client.interceptors.request.use(request => {
        const { token, mode } = useWorkflow()

        request.baseURL = getApiLink('executor', mode.value)
        request.headers['X-Engine-Type'] = 'WORKFLOW_EXECUTOR'
        // the gateway authorizes the header token, while custom-page-worker reads the token only from the query
        request.params = { ...request.params, token: token.value }

        return request
    })

    return client
}

export const useExecutorApi = () => {
    executorApiClient ??= createExecutorApi()

    return executorApiClient
}
